var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible ? _c("div", [_vm._m(0)]) : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gcloading" }, [
      _c("img", { attrs: { src: "/webAssets/images/img/animation_load.gif" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }